import React, { useMemo } from 'react';
import { Typography, Box, Button, GRAY } from '@applyboard/ui-components';
import { SectionHeader, SectionTitle, TitleIcons } from "./..";
import { extractMarks, getAreEnglishMarksValid } from "./utils";
import { ProgramEnglishRequirements, DelayedProofOfELPInfo, EnglishScoreRequired, GreRequirements } from "./AdmissionsRequirementsHelper";
import { AcademicBackground } from "./AcademicBackground";
import { MinimumLanguageTestScores } from "./MinimumLanguageTestScores";
import { displayDesktopOnly } from "../../consts";
export var AdmissionRequirements = function AdmissionRequirements(_ref) {
  var programRequirements = _ref.programRequirements,
    delayedProofOfElpValue = _ref.delayedProofOfElpValue,
    programEnglishRequirementExceptions = _ref.programEnglishRequirementExceptions,
    pepRequirements = _ref.pepRequirements,
    pepRequirementExceptions = _ref.pepRequirementExceptions,
    programLevel = _ref.programLevel,
    schoolName = _ref.schoolName,
    permissions = _ref.permissions,
    loginAndRedirectUrl = _ref.loginAndRedirectUrl,
    programId = _ref.programId;
  var areEnglishMarksValid = useMemo(function () {
    return getAreEnglishMarksValid(programRequirements === null || programRequirements === void 0 ? void 0 : programRequirements.minToeflTotal, programRequirements === null || programRequirements === void 0 ? void 0 : programRequirements.minIeltsAverage, programRequirements === null || programRequirements === void 0 ? void 0 : programRequirements.minPteOverall, programRequirements === null || programRequirements === void 0 ? void 0 : programRequirements.minDuolingoScore);
  }, [programRequirements === null || programRequirements === void 0 ? void 0 : programRequirements.minToeflTotal, programRequirements === null || programRequirements === void 0 ? void 0 : programRequirements.minIeltsAverage, programRequirements === null || programRequirements === void 0 ? void 0 : programRequirements.minPteOverall, programRequirements === null || programRequirements === void 0 ? void 0 : programRequirements.minDuolingoScore]);
  if (!programRequirements) {
    return null;
  }
  var marks = extractMarks(programRequirements);
  if (!programRequirements) {
    return null;
  }
  var minGpa = programRequirements.minGpa;
  return /*#__PURE__*/React.createElement(Box, {
    mb: 5,
    px: {
      xs: 3,
      md: 0
    }
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    mb: 3
  }, /*#__PURE__*/React.createElement(TitleIcons.AdmissionRequirements, null), /*#__PURE__*/React.createElement(SectionTitle, null, "Admission Requirements")), /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    mb: 3
  }), permissions.viewRequirementsAndFees ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(AcademicBackground, {
    levelText: programRequirements.levelText,
    minGpa: minGpa,
    programId: programId
  }), areEnglishMarksValid && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MinimumLanguageTestScores, {
    marks: marks
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 4
  }, programLevel !== 'english' && /*#__PURE__*/React.createElement(DelayedProofOfELPInfo, {
    value: delayedProofOfElpValue
  }), /*#__PURE__*/React.createElement(ProgramEnglishRequirements, {
    englishRequirementExceptions: programEnglishRequirementExceptions
  }), programLevel !== 'english' && /*#__PURE__*/React.createElement(EnglishScoreRequired, {
    englishScoreRequired: programRequirements.englishScoreRequired,
    schoolName: schoolName,
    marks: extractMarks(pepRequirements),
    englishRequirementExceptions: pepRequirementExceptions
  }))), /*#__PURE__*/React.createElement(GreRequirements, {
    greRequirements: programRequirements.greRequirements,
    pronoun: permissions.pronoun
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 3,
    display: displayDesktopOnly
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "legal",
    style: {
      color: GRAY[10]
    }
  }, "The program requirements above should only be used as a guide and do not guarantee admission into the program."))) : /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 2
  }, /*#__PURE__*/React.createElement(Button, {
    href: loginAndRedirectUrl
  }, "Log In to see Admission Requirements and Other Fees")));
};